export default "__VITE_ASSET__CWnlS2Lp__"